import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { trackEvent } from 'services/analytics'

const AnalyticsTracker = () => {
  const location = useLocation()

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return

    let country: string | undefined
    try {
      const storedUser = window.localStorage.getItem('user')
      country = storedUser ? JSON.parse(storedUser)?.country : undefined
    } catch {
      country = undefined
    }

    trackEvent({
      eventType: 'page_view',
      entityType: 'page',
      entityId: location.pathname,
      metadata: {
        referrer: document.referrer || null,
        device: /Mobi|Android/i.test(navigator.userAgent)
          ? 'mobile'
          : 'desktop',
        language: navigator.language || null,
        country: country || null
      }
    })
  }, [location.pathname])

  return null
}

export default AnalyticsTracker
